<template>
  <div class="revenue-container">
    <!-- 标题和操作按钮 -->

    <div class="header">
      <div class="title-container">
        <div class="title-line"></div>
        <h2>收益数据</h2>
      </div>
      <div class="actions">
        <el-button type="primary" @click="RefreshData">刷新数据</el-button>
      </div>
    </div>
    <!-- 收益统计卡片 -->
    <div class="stats-cards">
      <el-card shadow="hover">
        <div class="stat-item">
          <div class="stat-label">总余额</div>
          <div class="stat-value">¥{{ totalBalance || 0 }}</div>
          <el-button type="primary" size="small" @click="withdrawBalance" style="margin-top: 10px;">
            余额提现
          </el-button>
        </div>
      </el-card>
      <el-card shadow="hover">
        <div class="stat-item">
          <div class="stat-label">总积分</div>
          <div class="stat-value">{{ totalPoints || 0 }}</div>
          <el-button type="primary" size="small" @click="convertPoints" style="margin-top: 10px;">
            转换余额
          </el-button>
        </div>
      </el-card>
      <el-card shadow="hover">
        <div class="stat-item">
          <div class="stat-label">今日收入余额</div>
          <div class="stat-value">¥{{ todayBalance || 0 }}</div>
        </div>
      </el-card>
      <el-card shadow="hover">
        <div class="stat-item">
          <div class="stat-label">今日收入积分</div>
          <div class="stat-value">{{ todayPoints || 0 }}</div>
        </div>
      </el-card>
    </div>



    <!-- 数据表格 -->
    <div class="table-container">
      <div class="category-filter">
        <div style="margin-right: 10px;"> 选择分类:</div>
        <el-select v-model="selectedCategory" placeholder="请选择数据类型" style="width: 200px" @change="RefreshData">
          <el-option label="金额" value="金额"></el-option>
          <el-option label="积分" value="积分"></el-option>
        </el-select>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="order_no" label="原订单" width="120" />
        <el-table-column prop="before" :label="selectedCategory == '金额' ? '之前余额' : '之前积分'" width="120">
          <template #default="{ row }">
            {{ row.before || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="money" :label="selectedCategory == '金额' ? '变更金额' : '变更积分'" width="120">
          <template #default="{ row }">
            {{ row.money || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="after" :label="selectedCategory == '金额' ? '现金额' : '现积分'" width="120">
          <template #default="{ row }">
            {{ row.after || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="订单日期" width="120" />
        <el-table-column prop="createtime" label="订单时间" width="120">
          <template #default="{ row }">
            {{ formatDate(row.createtime) || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" />
      </el-table>
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" />
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'RevenueView',
  data() {
    return {
      totalBalance: 0,
      totalPoints: 0,
      todayBalance: 0,
      todayPoints: 0,
      selectedCategory: '金额',
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    RefreshData() {
      this.fetchData()
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000); // 转换成毫秒
      const Y = date.getFullYear();
      const M = String(date.getMonth() + 1).padStart(2, '0');
      const D = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const m = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    },
    fetchData() {
      this.loading = true
      const params = {
        type: this.selectedCategory,
        page: this.pagination.currentPage,
        size: this.pagination.pageSize
      }

      this.$axios.get('/api/Bloger/getmoeny', { 
        params,
        headers: {
          'token': localStorage.getItem('token') || ''
        }
      })
        .then(response => {
          this.tableData = response.data?.list || []
          this.pagination.total = response.data?.pagination?.total || 0
          this.totalBalance = response.data?.user_moeny || 0
          this.totalPoints = response.data?.user_points || 0
          this.todayBalance = response.data?.today_money_sum || 0
          this.todayPoints = response.data?.today_points_sum || 0
          if (this.tableData.length === 0) {
            this.$message.info('当前没有数据')
          }
        })
        .catch(error => {
          this.$message.error('获取数据失败: ' + error.message)
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    convertPoints() {
      this.$confirm('确定要将积分转换为余额吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/api/bloger/convertScoreToMoney')
          .then((res) => {
            console.log(res);
            if (res.code === 1) {
              this.$message.success('转换成功')
              this.fetchData() // 刷新统计数据
            } else {
              this.$message.error(res.msg || '转换失败')
            }
          })
          .catch(error => {
            this.$message.error('转换失败: ' + error.message)
          })
      }).catch(() => { })
    },
    withdrawBalance() {
      // 先让用户输入提现金额
      this.$prompt('请输入提现金额', '余额提现', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: '请输入有效的金额格式（如：100 或 100.50）',
        inputValue: this.totalBalance > 0 ? this.totalBalance.toString() : ''
      }).then(({ value }) => {
        const amount = parseFloat(value)

        // 验证提现金额
        if (amount <= 0) {
          this.$message.error('提现金额必须大于0')
          return
        }

        if (amount > this.totalBalance) {
          this.$message.error('提现金额不能超过可用余额')
          return
        }

        // 获取提现手续费率
        this.$axios.get('/api/bloger/withdrawFee')
          .then(response => {
            const feeRate = response.data?.fee_rate || 0.06 // 默认6%手续费

            // 计算手续费和实际到账金额
            const fee = amount * feeRate
            const actualAmount = amount - fee

            // 创建美观的确认弹窗内容（两列布局）
            const confirmContent = `
              <div class="withdraw-confirm">
                <div class="confirm-grid">
                  <div class="grid-row">
                    <div class="grid-item">
                      <span class="item-label">提现金额：</span>
                      <span class="item-value highlight">¥${amount.toFixed(2)}</span>
                    </div>
                    <div class="grid-item">
                      <span class="item-label">手续费率：</span>
                      <span class="item-value">${(feeRate * 100).toFixed(2)}%</span>
                    </div>
                  </div>
                  <div class="grid-row">
                    <div class="grid-item">
                      <span class="item-label">手续费：</span>
                      <span class="item-value">¥${fee.toFixed(2)}</span>
                    </div>
                    <div class="grid-item">
                      <span class="item-label">实际到账：</span>
                      <span class="item-value total-amount">¥${actualAmount.toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              </div>
            `

            // 显示确认弹窗
            this.$confirm(
              confirmContent,
              '确认提现',
              {
                confirmButtonText: '确认提现',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                customClass: 'withdraw-confirm-dialog'
              }
            ).then(() => {
              // 提交提现申请
              this.$axios.post('/api/bloger/withdraw', {
                amount: amount,
              })
                .then((res) => {
                  if ( res.code === 1) {
                    this.$message.success(res.msg||'提现申请已提交，请等待审核')
                    this.fetchData() // 刷新统计数据
                  } else {
                    this.$message.error(res.msg || '提现失败')
                  }
                })
                .catch(error => {
                  this.$message.error('提现失败: ' + error.message)
                })
            }).catch(() => {
              // 用户取消提现
            })
          })
          .catch(error => {
            this.$message.error('获取手续费信息失败: ' + error.message)
          })
      }).catch(() => {
        // 用户取消输入
      })
    }
  }
}
</script>

<style scoped>
.works {
  padding: 24px;
  background-color: #f5f7fa;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.title-container {
  display: flex;
  align-items: center;
}

.title-line {
  width: 4px;
  height: 24px;
  background: linear-gradient(to bottom, #1890ff, #52c41a);
  margin-right: 12px;
  border-radius: 2px;
}

h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.actions {
  display: flex;
  gap: 12px;
}

.revenue-container {
  padding: 20px;
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
}

.filter-container {
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.table-container {
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.pagination-container {
  text-align: right;
  margin-top: 10px;
}

.category-filter {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.works-container {
  background-color: #fff;
  padding: 10px;
}

.withdraw-confirm {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #303133;
  padding: 16px 20px;
}

.confirm-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.grid-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.grid-item {
  display: flex;
  flex-direction: column;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.item-label {
  color: #606266;
  font-size: 13px;
  margin-bottom: 5px;
}

.item-value {
  font-weight: 600;
  color: #303133;
  font-size: 15px;
}

.highlight {
  color: #409EFF;
}

.total-amount {
  color: #67C23A;
  font-size: 16px;
  font-weight: 700;
}
</style>
